import * as React from "react";
import {useEffect, useState} from "react";
import {getInsuranceDetails, getSubmitButton} from "insurance/forms/utils";
import TabContent from "../components/tabContent";
import {RouteComponentProps} from "react-router-dom";
import {handleNavigation} from "insurance/routes";
import {RoutePaths} from "insurance/routes";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {IInsuraceProduct} from "StateInterface";
import Modal from "components/Modal";
import {downloadPDF} from "insurance/utils";
import {downloadPolicyEvent, insuranceProceedEvent, subProductViewEvent} from "insurance/events";

interface IConnectProps {
    insuranceProducts: IInsuraceProduct[];
    selectedProductIndex: number;
    isAndroid: boolean;
}

function ProductDetails(props: IConnectProps & RouteComponentProps) {
    const [isChecked, updateIsChecked] = useState<boolean>(false);
    const [isModalActive, updateIsModalActive] = useState<boolean>(false);
    const selectedProductIndex = props.selectedProductIndex;
    const insuranceProducts = props.insuranceProducts;
    const isDeclarationRequired = insuranceProducts[selectedProductIndex].declarationFields.length > 0;
    const isDeclarationChecked = isChecked || !isDeclarationRequired;
    if (selectedProductIndex === null) return null;

    useEffect(() => {
        const product = insuranceProducts[selectedProductIndex];
        subProductViewEvent(product);
    }, [selectedProductIndex]);

    const handleProceed = () => {
        handleNavigation(RoutePaths.USER_DETAILS);
        insuranceProceedEvent(insuranceProducts[selectedProductIndex].productTitle);
    };
    const handleChecked = () => {
        updateIsChecked(!isChecked);
    };
    const handleTncClicked = () => {
        updateIsModalActive(true);
    };
    const downloadPolicyClicked = (link: string, name: string, isAndroid: boolean) => {
        downloadPDF(link, name, isAndroid);
        downloadPolicyEvent(insuranceProducts[selectedProductIndex].productTitle);
    };
    function renderDeclarationModal(declarationFields) {
        return(
            <Modal title={"Declarations"}
                   active={isModalActive}
                   cancellable={true}
                   titleBarBgColor={"#f5821fc4"}
                   titleFontColor={"#FFFFFF"}
                   onClose={() => updateIsModalActive(false)}>
                <div>
                    {declarationFields.length > 0 && declarationFields.map((field, index) => {
                        return <p key={index}> {field}</p>;
                    })}
                </div>
            </Modal>
        );
    }
   
    return(
        <div className="mt-1 p-2">
            {getInsuranceDetails(insuranceProducts[selectedProductIndex])}
            <div className="mt-3 pt-4">
                <TabContent	
                    details={insuranceProducts[selectedProductIndex].policyCovers}	
                    productDetails={insuranceProducts[selectedProductIndex]}	
                />
            </div>
            <p className="download-policy text-center"
               onClick={() => downloadPolicyClicked(insuranceProducts[selectedProductIndex].termsAndCondition,
                   `${insuranceProducts[selectedProductIndex].productTitle}`, props.isAndroid)}>
                Download Policy Terms
            </p>
            {isDeclarationRequired &&
            <p className="checkbox checkbox-tnc">
                <input type="checkbox"
                       onChange={handleChecked}
                       name="terms"/> I hereby make these <span className="tnc-text" onClick={handleTncClicked}> declarations</span>
            </p>
            }
            {renderDeclarationModal(insuranceProducts[selectedProductIndex].declarationFields)}
            {getSubmitButton("Proceed", handleProceed, isDeclarationChecked)}
            <div className={"text-center mt-4 small-text pb-2 color-lightgray"}>Powered By
                <b> {insuranceProducts[selectedProductIndex].insurer.name}</b>.
            </div>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        insuranceProducts: state.insurance.insuranceProducts,
        selectedProductIndex: state.insurance.selectedProductIndex,
        isAndroid: state.login.isAndroid,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(ProductDetails);
